module.exports = __webpack_public_path__ + "media/images/illustrations/Icon-Mentorship-b2f9e4f212a638d8f867fb58ebac2117.svg";